export default "__VITE_ASSET__9ef6ac6b__"